import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMindsComponent } from './simple-icons-minds.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMindsComponent ],
    exports:      [ SimpleIconsMindsComponent ],
    bootstrap:    []
})
export class SimpleIconsMindsModule {}
